import { z } from 'zod';
import { MailboxFilingWriteSchema, MailboxFilingMarkSchema, MailboxFilingsResponseSchema, type MailboxFilingMark } from './mailboxFiling';

/** Compatibility names for existing Gmail clients; both providers use the same provenance contract. */
export const GmailFilingWriteSchema = MailboxFilingWriteSchema;
export const GmailFilingMarkSchema = MailboxFilingMarkSchema;
export const GmailFilingResponseSchema = z.object({ mark: GmailFilingMarkSchema.nullable() }).strict();
export const GmailFilingsResponseSchema = MailboxFilingsResponseSchema;
export type GmailFilingMark = MailboxFilingMark;
